import lib from "zeta-dom";
const dom = lib.dom;
export default dom;
const { beginDrag, blur, focus, focusable, focused, releaseFocus, releaseModal, reportError, retainFocus, setModal, setTabRoot, textInputAllowed, unsetTabRoot } = dom;
export { beginDrag, blur, focus, focusable, focused, releaseFocus, releaseModal, reportError, retainFocus, setModal, setTabRoot, textInputAllowed, unsetTabRoot };